import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './OrderTime.css';
import Header from "../common/Header";
import httpService from "../../services/HttpService";

const OrderTime = () => {
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [orderId, setOrderId] = useState(null);
    const [days, setDays] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const savedOrderId = localStorage.getItem('pending_order_id');
        if (savedOrderId) {
            setOrderId(savedOrderId);
            fetchSlots(savedOrderId);
        } else {
            console.log('No orderId found in localStorage');
        }
    }, []);


    const fetchSlots = async (id) => {
        try {
            const response = await httpService.get(`/orders/${id}/slots`);
            const data = await response.json();
            setDays(data.days || []);
        } catch (error) {
            console.error('Ошибка при загрузке слотов:', error);
            alert('Не удалось загрузить слоты доставки');
        }
    };

    const handleDeliveryClick = async () => {
        if (selectedDate === null || selectedTime === null) {
            alert('Пожалуйста, выберите дату и время доставки');
            return;
        }

        const dayObj = days[selectedDate];
        if (!orderId || !dayObj?.day || !selectedTime) {
            alert('Не хватает данных для оформления доставки');
            return;
        }

        try {
            const response = await httpService.put(`/orders/${orderId}`, {
                date: dayObj.value,
                time: selectedTime,
            });

            await response.json();

            const authToken = localStorage.getItem('auth_token');
            if (authToken) {
                navigate('/order-payment');
            } else {
                navigate('/order-user', { state: { to: '/order-payment' } });
            }
        } catch (error) {
            console.error('Ошибка при обновлении заказа:', error);
            alert('Ошибка при выборе доставки');
        }
    };

    const getTimeSlotsForSelectedDate = () => {
        if (selectedDate === null) return [];
        return days[selectedDate]?.time_slots || [];
    };
    
    const {cityId} = JSON.parse(localStorage.getItem('pending_order'))

    if (cityId > 38){
        navigate('/order-payment');
        return null;
    }

    return (
        <>
            <Header />
            <div className="ot-page">
                <div className="ot-page-container">
                    <div className="ot-title">Дата и время доставки</div>

                    <div className="ot-date-container">
                        {days.map((dayObj, index) => (
                            <div
                                key={index}
                                className={`ot-date-block ${selectedDate === index ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelectedDate(index);
                                    setSelectedTime(null); // сбрасываем выбранное время при смене даты
                                }}
                            >
                                <span className="order-time-date-button">{dayObj.day}</span>
                                <span className="order-time-day-name">{dayObj.weekday}</span>
                            </div>
                        ))}
                    </div>

                    <div className="order-time-time-slots">
                        {getTimeSlotsForSelectedDate().map((slot, index) => (
                            <button
                                key={index}
                                className={`order-time-time-slot-button ${selectedTime === slot ? 'selected' : ''}`}
                                onClick={() => setSelectedTime(slot)}
                            >
                                {slot}
                                {/*<span className="ot-price">0 ₽</span>*/}
                            </button>
                        ))}
                        {selectedDate !== null && getTimeSlotsForSelectedDate().length === 0 && (
                            <div className="ot-no-slots">Нет доступных слотов на этот день</div>
                        )}
                    </div>
                </div>

                <button className="default-button" onClick={handleDeliveryClick}>
                    Доставить {selectedTime ? `${selectedTime}` : 'выберите время'}
                </button>
            </div>
        </>
    );
};

export default OrderTime;